import { useEffect, useState } from "react";
import { checkOpenedReport } from "services";
import { setCheckOpenedReportLoadStatus } from "store/slicer/CheckOpenedReportSlice";
import { useAppDispatch, useAppSelector } from "store/store";

export const OpenedReportIndicator = () => {
  const [hasOpenedReport, setHasOpenedReport] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const checkOpenedReportLoadStatus = useAppSelector(
    (state) => state.checkOpenedReportSlice
  );

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (!checkOpenedReportLoadStatus) {
      checkOpenedReport()
        .then((response) => {
          setHasOpenedReport(response.data.opendeReport);
        })
        .catch((_) => {})
        .finally(() => {
          dispatch(setCheckOpenedReportLoadStatus(true));
        });
    } else {
      timer = setTimeout(() => {
        dispatch(setCheckOpenedReportLoadStatus(false));
      }, 300000);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [checkOpenedReportLoadStatus, dispatch]);

  return hasOpenedReport ? (
    <div className="opened-report-indicator"></div>
  ) : null;
};
